/* NAELLIA Markets display layer. Only customer-facing labels change.
   Selected variant option strings always stay identical to Shopify's values. */
(function () {
  'use strict';
  var settings = (window.Naellia && window.Naellia.market) || {};
  var country = String(settings.country || 'AU').toUpperCase();
  var currency = String(settings.currency || 'AUD').toUpperCase();
  var locale = String(settings.locale || ('en-' + country));
  var auMap = {
    '4':4,'au4':4,'uk4':4,'xxs':4,'2xs':4,'eu32':4,'32':4,
    '6':6,'au6':6,'uk6':6,'xs':6,'eu34':6,'34':6,
    '8':8,'au8':8,'uk8':8,'s':8,'eu36':8,'36':8,
    '10':10,'au10':10,'uk10':10,'s/m':10,'sm':10,'eu38':10,'38':10,
    '12':12,'au12':12,'uk12':12,'m':12,'eu40':12,'40':12,
    '14':14,'au14':14,'uk14':14,'l':14,'eu42':14,'42':14,
    '16':16,'au16':16,'uk16':16,'l/xl':16,'lxl':16,'eu44':16,'44':16,
    '18':18,'au18':18,'uk18':18,'xl':18,'xlarge':18,'x/large':18,'eu46':18,'46':18,
    '20':20,'au20':20,'uk20':20,'xxl':20,'2xl':20,'xxlarge':20,'xx/large':20,'eu48':20,'48':20,
    '22':22,'au22':22,'uk22':22,'xxxl':22,'3xl':22,'eu50':22,'50':22,
    '24':24,'au24':24,'uk24':24,'4xl':24,'eu52':24,'52':24,
    '26':26,'au26':26,'uk26':26,'5xl':26,'eu54':26,'54':26
  };
  // Product type (not the numeric value alone) determines the size system.
  // Shopify Ajax /cart.js items may only expose product_title and product_type.
  function isFootwear(product) {
    if (!product) return false;
    var tags = Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '');
    var text = [product.type, product.product_type, product.title,
      product.product_title, product.handle, tags].filter(Boolean).join(' ');
    return /\b(footwear|shoes?|sandals?|heels?|boots?|sneakers?|trainers?|loafers?|slippers?|espadrilles?|mules?|pumps?|flats?|flip.flops?)\b/i.test(text)
      && !/\bbootcut\b/i.test(text);
  }
  function normalise(value) {
    return String(value == null ? '' : value).trim().toLowerCase()
      .replace(/[\s_]/g, '').replace(/[–—−-]/g, '/');
  }
  function auNumber(value) {
    var key = normalise(value);
    return Object.prototype.hasOwnProperty.call(auMap, key) ? auMap[key] : null;
  }
  function auPair(value) {
    var key = normalise(value);
    // S/M and L/XL are deliberate single reference sizes in the existing chart.
    if (Object.prototype.hasOwnProperty.call(auMap, key)) return null;
    var parts = key.split('/');
    if (parts.length !== 2) return null;
    var first = auNumber(parts[0]), second = auNumber(parts[1]);
    if (first === null || second === null || first === second) return null;
    return [first, second];
  }

  // Women's footwear, source scale is read from the variant value itself.
  // AU/US numbers are equivalent in the chart used here; EU and UK vary.
  // Values with no explicit prefix: 35–45 = EU, 4–14 = AU/US.
  // Manufacturer-specific fit is not guaranteed; these are display conversions.
  var euToAuShoe = {
    '35':4,'35.5':4.5,'36':5,'36.5':5.5,'37':6,'37.5':6.5,
    '38':7,'38.5':7.5,'39':8,'39.5':8.5,'40':9,'40.5':9.5,
    '41':10,'41.5':10.5,'42':11,'42.5':11.5,'43':12,
    '43.5':12.5,'44':13,'44.5':13.5,'45':14
  };
  function auShoeNumber(value, inheritedScale) {
    var token = String(value || '').trim().replace(/^size\s+/i, '');
    var match = token.match(/^(EU|EUR|AU|US|UK|NZ)?\s*(\d{1,2}(?:\.5)?)$/i);
    if (!match) return null;
    var scale = (match[1] || inheritedScale || '').toUpperCase();
    var n = Number(match[2]);
    if (!scale) scale = n >= 35 && n <= 45 ? 'EU' : 'AU';
    if (scale === 'EU' || scale === 'EUR')
      return Object.prototype.hasOwnProperty.call(euToAuShoe, match[2]) ? euToAuShoe[match[2]] : null;
    if (scale === 'UK') { n += 2; }
    if (scale === 'AU' || scale === 'US' || scale === 'NZ' || scale === 'UK')
      return n >= 4 && n <= 14 && (n * 2) % 1 === 0 ? n : null;
    return null;
  }
  function shoeSizeLabel(value) {
    var raw = String(value == null ? '' : value).trim();
    var clean = raw.replace(/[–—−-]/g, '/');
    var parts = clean.split(/\s*\/\s*/);
    if (parts.length > 2) return raw;
    var commonScale = (parts[0].match(/^\s*(EU|EUR|AU|US|UK|NZ)\b/i) || [])[1];
    var numbers = parts.map(function (part) { return auShoeNumber(part, commonScale); });
    if (numbers.some(function (n) { return n === null; })) return raw;
    var target = country === 'GB' ? 'UK' : country === 'NZ' ? 'US' : 'AU';
    if (target === 'UK') numbers = numbers.map(function (n) { return n - 2; });
    return target + ' ' + numbers.join('/');
  }
  function sizeLabel(value, product) {
    var raw = String(value == null ? '' : value).trim();
    if (isFootwear(product)) return shoeSizeLabel(raw);
    var single = auNumber(raw);
    var pair = single === null ? auPair(raw) : null;
    if (single === null && !pair) return raw;
    var numbers = (pair || [single]).map(function (n) { return country === 'NZ' ? n - 4 : n; });
    return (country === 'NZ' ? 'US ' : country === 'GB' ? 'UK ' : 'AU ') + numbers.join('/');
  }
  function formatMoney(cents) {
    var number = (Number(cents) || 0) / 100;
    try { return new Intl.NumberFormat(locale, {style:'currency',currency:currency}).format(number); }
    catch (e) { return currency + ' ' + number.toFixed(2); }
  }
  window.NaelliaMarket = { country:country, currency:currency, locale:locale,
    sizeLabel:sizeLabel, shoeSizeLabel:shoeSizeLabel, auNumber:auNumber, auPair:auPair, formatMoney:formatMoney, isFootwear:isFootwear };
})();
